import React from 'react'
import { InputSingleTextNextButton } from '../../../../../../../ui/organisms'

export default {
  title: 'Enter a name for this project',
  next: '',
  component: (props) => (
    <InputSingleTextNextButton
      placeHolder={'Project Name'}
      required
      {...props}
    />
  ),
}
